import { render } from "./ModalKeyWord.vue?vue&type=template&id=b4355d04&scoped=true"
import script from "./ModalKeyWord.vue?vue&type=script&lang=js"
export * from "./ModalKeyWord.vue?vue&type=script&lang=js"

import "./ModalKeyWord.vue?vue&type=style&index=0&id=b4355d04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4355d04"]])

export default __exports__